import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useInvoice from '@hooks/useInvoice'
import type { UseCampaignAccountingPayload } from '@hooks/useCampaignAccounting'

import type { CampaignModel, InvoiceModel } from '@models/types'

import InvoiceListItem from './PendingInvoiceListItem'

type PendingInvoicesProps = {
  accountingPayload: UseCampaignAccountingPayload,
  campaign: CampaignModel,
}

const PendingInvoices = (props: PendingInvoicesProps) => {
  const { accountingPayload: { loading, pendingInvoices }, campaign } = props

  const initInvoice = {
    campaign_id: campaign.id,
    creditor_id: campaign.agency_id,
    creditor_type: 'Agency',
  }

  const useInvoicePayload = useInvoice(initInvoice)
  const { callbacks: { createOrEditInvoice } } = useInvoicePayload

  const hasPendingInvoices = !!pendingInvoices.length

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Pending Invoices"
    >
      {!loading && !hasPendingInvoices && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Pending Invoices Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      <Box flexDirection="column">
        {pendingInvoices.map((invoice: InvoiceModel) => (
          <InvoiceListItem campaign={campaign} invoice={invoice} key={invoice.id} />
        ))}
      </Box>

      <DashboardModule.Footer
        boxProps={{ borderTop: !loading ? '1px solid' : 'none' }}
      >
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditInvoice()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Invoice
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default PendingInvoices
